import React from "react";
import { useTranslation } from "react-i18next";
import { Banner } from "fe-shared/src/components";

import styles from "./IsWebCreatedBanner.module.scss";

const IsWebCreatedBanner = () => {
  const { t } = useTranslation();

  return (
    <Banner
      variant="info"
      title={t("createReceiptDialog.banner.createdOnWeb")}
      id="transaction-created-on-web-banner"
      className={styles.createdOnWebBanner}
    />
  );
};

export default IsWebCreatedBanner;
